import React, { useCallback, useEffect, useState } from "react";
import Joyride from "react-joyride";

import { updateCoachMark } from "services";

import { useCancelAsyncOnUnmount, useTranslation, useUserContext } from "utils";

import { Divider } from "components";

export const CoachMark = ({ type, location, hideTitle = false }) => {
  const { t } = useTranslation("coachMarks");
  const { user } = useUserContext();

  const [show, setShow] = useState(false);
  const signal = useCancelAsyncOnUnmount()();

  const checkExists = useCallback(() => {
    if (!document.getElementById(type)) {
      setShow(true);
    }
  }, [type]);

  const checkCoachMarkViewed = useCallback(() => {
    if (type === "storybook") {
      setShow(true);
    }

    updateCoachMark({
      type: type,
      signal,
    }).then((res) => {
      if (res.allowed) {
        checkExists();
      }
    });
  }, [checkExists, type, signal]);

  useEffect(() => {
    if (user) {
      checkCoachMarkViewed();
    }
  }, [checkCoachMarkViewed, user]);

  return (
    show && (
      <div id={type}>
        <Joyride
          run={true}
          locale={{ close: t("gotIt") }}
          steps={[
            {
              target: `.${location}`,
              content: (
                <>
                  {!hideTitle && (
                    <>
                      <h4 className="left white-text">{t(`${type}.title`)}</h4>
                      <Divider />
                    </>
                  )}
                  <p className="left white-text margin-bottom-0">{t(`${type}.description`)}</p>
                </>
              ),
              disableBeacon: true,
            },
          ]}
          styles={{
            options: { arrowColor: "#065c45" },
            buttonNext: { display: "none" },
            buttonClose: { color: "#fff" },
          }}
        />
      </div>
    )
  );
};

export default CoachMark;
